import { Animation, createAnimation } from "@ionic/core";

export namespace CustomAnimation {
  const zeroDigit = 0;
  export function enterFromRight(): any {
    // Add null safety checks for modal elements early
    const backdropElement = document.querySelector("ion-backdrop");
    const modalWrapperElement = document.querySelector(".modal-wrapper");
    
    // If elements don't exist, return an empty animation to prevent errors
    if (!backdropElement || !modalWrapperElement) {
      return createAnimation()?.duration(0);
    }

    const backdropAnimation = createAnimation();
    backdropAnimation?.addElement(backdropElement);

    backdropAnimation?.fromTo("opacity", 0.01, 0.4);

    const wrapperAnimation = createAnimation();
    wrapperAnimation?.addElement(modalWrapperElement);

    const wrapperElem = createAnimation("modalEnter_wrapperElem")?.addElement(modalWrapperElement);
    if (!wrapperElem || !wrapperElem.elements[zeroDigit] || !wrapperElem.elements[zeroDigit].style) {
      return createAnimation()?.duration(0);
    }
    wrapperElem.elements[zeroDigit].style.left = "0";

    wrapperAnimation
      ?.beforeStyles({ transform: "translateX(100%);", opacity: 1 })
      ?.fromTo("transform", "translateX(100%)", "translateX(0)")
      ?.fromTo("opacity", 1, 1);

    const baseAnimation = createAnimation()
      ?.addElement(wrapperElem.elements[zeroDigit])
      ?.duration(500)
      ?.beforeAddClass("show-modal")
      ?.addAnimation(backdropAnimation)
      ?.addAnimation(wrapperAnimation);
    return baseAnimation;
  }

  export function exitThroughRight(): any {
    // Add null safety checks for modal elements early
    const backdropElement = document.querySelector("ion-backdrop");
    const modalWrapper = document.querySelector(".modal-wrapper") as HTMLElement;
    
    // If elements don't exist, return an empty animation to prevent errors
    if (!backdropElement || !modalWrapper) {
      return createAnimation()?.duration(0);
    }

    const backdropAnimation = createAnimation();
    backdropAnimation?.addElement(backdropElement);

    backdropAnimation?.fromTo("opacity", 0.4, 0.0);

    const wrapperAnimation = createAnimation();
    wrapperAnimation?.addElement(modalWrapper);

    const wrapperElem = createAnimation("modalEnter_wrapperElem")?.addElement(modalWrapper);
    if (!wrapperElem || !wrapperElem.elements[zeroDigit]) {
      return createAnimation()?.duration(0);
    }

    wrapperAnimation
      ?.addElement(modalWrapper)
      ?.beforeStyles({ transform: "translateX(100%)", opacity: 1, left: "0" })
      ?.fromTo("transform", "translateX(0)", "translateX(100%)")
      ?.fromTo("opacity", 1, 1);

    const baseAnimation = createAnimation()
      ?.addElement(wrapperElem.elements[zeroDigit])
      ?.duration(500)
      ?.addAnimation(backdropAnimation)
      ?.addAnimation(wrapperAnimation);

    return baseAnimation;
  }

  export function scaleIn(): any {
    // Add null safety check for modal wrapper element
    const modalWrapperElement = document.querySelector(".modal-wrapper");
    
    // If element doesn't exist, return an empty animation to prevent errors
    if (!modalWrapperElement) {
      return createAnimation()?.duration(0);
    }

    const wrapperAnimation = createAnimation();
    wrapperAnimation?.addElement(modalWrapperElement);

    wrapperAnimation
      ?.addElement(modalWrapperElement)
      ?.beforeStyles({ transform: "scale(0)", opacity: 1 })
      ?.fromTo("transform", "scale(0)", "scale(1)")
      ?.fromTo("opacity", 0, 1);

    const baseAnimation = createAnimation()?.addElement(document)?.duration(500)?.addAnimation(wrapperAnimation);

    return baseAnimation;
  }

  export function scaleOut(): any {
    // Add null safety check for modal wrapper element
    const modalWrapperElement = document.querySelector(".modal-wrapper");
    
    // If element doesn't exist, return an empty animation to prevent errors
    if (!modalWrapperElement) {
      return createAnimation()?.duration(0);
    }

    const wrapperAnimation = createAnimation();
    wrapperAnimation?.addElement(modalWrapperElement);

    wrapperAnimation
      ?.addElement(modalWrapperElement)
      ?.beforeStyles({ transform: "scale(1)", opacity: 0 })
      ?.fromTo("transform", "scale(1)", "scale(0)")
      ?.fromTo("opacity", 1, 0);

    const baseAnimation = createAnimation()?.addElement(document)?.duration(500)?.addAnimation(wrapperAnimation);

    return baseAnimation;
  }
}
